'use client'

import React from 'react'
import { motion } from 'framer-motion'
import type { RenderedService, ServiceItem } from '@/types/interfaces/service-item'
import { staggerContainer } from '@/lib/animations'
import Card, {
    type BackgroundKey,
    type Columns,
    type SubtitleLeadingKey,
} from './Card'
import classes from './Row.module.css'

export interface CardData {
    title: string
    subtitle?: string
    subtitleLeading?: SubtitleLeadingKey
    note?: string
    href?: string
    background?: BackgroundKey
    columns: Columns
    services: ServiceItem[]
}

export interface RowProps {
    featuredCategoryRow: RenderedService
    /** Eager-load the first card background when this row owns the page LCP image. */
    prioritizeFirstCardBackground?: boolean
}

export default function Row({
    featuredCategoryRow,
    prioritizeFirstCardBackground = false,
}: RowProps) {
    const cards = (featuredCategoryRow as { cards?: CardData[] }).cards ?? []

    if (cards.length === 0) return null

    return (
        <motion.div
            className={classes.row}
            data-featured-category-row={featuredCategoryRow.id}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-80px 0px' }}
            variants={staggerContainer}
        >
            {cards.map((card, index) => (
                <Card
                    key={`${card.title}-${index}`}
                    title={card.title}
                    subtitle={card.subtitle}
                    subtitleLeading={card.subtitleLeading}
                    note={card.note}
                    href={card.href}
                    background={card.background}
                    columns={card.columns}
                    services={card.services}
                    priority={prioritizeFirstCardBackground && index === 0}
                />
            ))}
        </motion.div>
    )
}
